/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class2;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from "@ember/object";
import Component from "@glimmer/component";
import { ForcBaseArgs } from "core/components/forc/abstract/base-component";
import Patient from "core/models/patient";
import { EmberChangeset } from "ember-changeset";
import emberSwal from "ui-kit/utils/ember-swal";
import AbdominalPain from "./abdominal-pain";
import AbdominalPainIntensity from "./abdominal-pain-intensity";
import AnalIncontinence from "./anal-incontinence";
import AnalIncontinenceFrequency from "./anal-incontinence-frequency";
import AnusSymptoms from "./anus-symptoms";
import AnusSymptomsFrequency from "./anus-symptoms-frequency";
import ArticularPain from "./articular-pain";
import ArticularPainIbd from "./articular-pain-ibd";
import ArticularPainSeverity from "./articular-pain-severity";
import AverageStoolsNumber from "./average-stools-number";
import BloodInStool from "./blood-in-stool";
import BloodInStoolFrequency from "./blood-in-stool-frequency";
import BodyDissatisfaction from "./body-dissatisfaction";
import EditionForm from "./edition-form";
import EyeSymptoms from "./eye-symptoms";
import EyeSymptomsPainful from "./eye-symptoms-painful";
import EyeSymptomsRedEye from "./eye-symptoms-red-eye";
import EyeSymptomsSight from "./eye-symptoms-sight";
import Fever from "./fever";
import FeverLevel from "./fever-level";
import FistulasEmbarrassment from "./fistulas-embarrassment";
import FistulasFlow from "./fistulas-flow";
import FistulasMovement from "./fistulas-movement";
import FistulasPain from "./fistulas-pain";
import FistulasPainSkin from "./fistulas-pain-skin";
import HasFistulas from "./has-fistulas";
import ImmediateStool from "./immediate-stool";
import ImmediateStoolUrgency from "./immediate-stool-urgency";
import LackOfEnergy from "./lack-of-energy";
import LowMood from "./low-mood";
import MouthUlcers from "./mouth-ulcers";
import RepeatedVomiting from "./repeated-vomiting";
import SexualDifficulties from "./sexual-difficulties";
import SkinSymptoms from "./skin-symptoms";
import SleepDifficulties from "./sleep-difficulties";
import Slider from "./slider";
import SocialDifficulties from "./social-difficulties";
import StomachPain from "./stomach-pain";
import StoolsNumber from "./stools-number";
import TransitBlockage from "./transit-blockage";
import UrgentStoolsMovements from "./urgent-stools-movements";
import Weight from "./weight";
import WellBeing from "./well-being";
import WorkDifficulties from "./work-difficulties";
const Questions = {
  "abdominal-pain": AbdominalPain,
  "abdominal-pain-intensity": AbdominalPainIntensity,
  "anal-incontinence": AnalIncontinence,
  "anal-incontinence-frequency": AnalIncontinenceFrequency,
  "anus-symptoms": AnusSymptoms,
  "anus-symptoms-frequency": AnusSymptomsFrequency,
  "articular-pain": ArticularPain,
  "articular-pain-ibd": ArticularPainIbd,
  "articular-pain-severity": ArticularPainSeverity,
  "average-stools-number": AverageStoolsNumber,
  "blood-in-stool": BloodInStool,
  "blood-in-stool-frequency": BloodInStoolFrequency,
  "body-dissatisfaction": BodyDissatisfaction,
  "edition-form": EditionForm,
  "eye-symptoms": EyeSymptoms,
  "eye-symptoms-painful": EyeSymptomsPainful,
  "eye-symptoms-red-eye": EyeSymptomsRedEye,
  "eye-symptoms-sight": EyeSymptomsSight,
  fever: Fever,
  "fever-level": FeverLevel,
  "fistulas-embarrassment": FistulasEmbarrassment,
  "fistulas-flow": FistulasFlow,
  "fistulas-movement": FistulasMovement,
  "fistulas-pain": FistulasPain,
  "fistulas-pain-skin": FistulasPainSkin,
  "has-fistulas": HasFistulas,
  "immediate-stool": ImmediateStool,
  "immediate-stool-urgency": ImmediateStoolUrgency,
  "lack-of-energy": LackOfEnergy,
  "low-mood": LowMood,
  "mouth-ulcers": MouthUlcers,
  "repeated-vomiting": RepeatedVomiting,
  "sexual-difficulties": SexualDifficulties,
  "skin-symptoms": SkinSymptoms,
  "sleep-difficulties": SleepDifficulties,
  slider: Slider,
  "social-difficulties": SocialDifficulties,
  "stomach-pain": StomachPain,
  "stools-number": StoolsNumber,
  "transit-blockage": TransitBlockage,
  "urgent-stools-movements": UrgentStoolsMovements,
  weight: Weight,
  "well-being": WellBeing,
  "work-difficulties": WorkDifficulties
};
let _class = (_class2 = class _class2 extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Questions", Questions);
  }
  async save() {
    await this.args.save().then(async () => {
      const swalText = this.args.patient.healthCentre.controlGroupCentre ? "Merci pour votre contribution, en complétant ce questionnaire vous permettez d’améliorer notre compréhension des soins à distance. Grâce à vous, nous pourrons mieux évaluer l’efficacité des solutions de télésurveillance dans le suivi des patients atteints de maladies chroniques de l’intestin. DigestWise n'est pas un canal d'urgence. Appelez le 112 ou le 15 pour les urgences." : "L'équipe soignante va prendre connaissance de vos réponses. DigestWise n'est pas un canal d'urgence. Appelez le 112 ou le 15 pour les urgences.";
      emberSwal.fire({
        text: swalText,
        icon: "success",
        confirmButtonText: "Ok"
      });
    });
  }
}, _applyDecoratedDescriptor(_class2.prototype, "save", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "save"), _class2.prototype), _class2);
export { _class as default };